import {
  ICircleOptions,
  IEllipseOptions,
  ILineOptions,
  IPathOptions,
  IPolylineOptions,
  IRectOptions,
  ITriangleOptions,
} from 'fabric/fabric-impl';

interface PointModel {
  x: number;
  y: number;
}

export interface PartModel {
  type: string;
  line?: number[];
  path?: string;
  definition:
    | DefinitionModel
    | ICircleOptions
    | IEllipseOptions
    | ILineOptions
    | IPathOptions
    | IPolylineOptions
    | IRectOptions
    | ITriangleOptions;
  definitionText?: PropertiesTextModel;
  definitionPoly?: PointModel[];
}

export interface PropertiesTextModel {
  direction?: string;
  font_size?: number;
  name?: string;
  text?: string;
  top?: number;
  left?: number;
}

export interface DefinitionModel {
  left?: number;
  top?: number;
  width?: number;
  height?: number;
  originX?: string;
  originY?: string;
  radius?: number;
  angle?: number;
  fill?: string;
  stroke?: string;
}

export enum PolygonObject {
  CIRCLE = 'circle',
  ELLIPSE = 'ellipse',
  LINE = 'line',
  PATH = 'path',
  POLYGON = 'polygon',
  POLYLINE = 'polyline',
  RECT = 'rect',
  TRIANGLE = 'triangle',
  TEXT = 'text',
}

export interface MapObjectModel {
  type: string;
  object: any;
  parts?: MapObjectModel[];
}